module.exports = __webpack_public_path__ + "static/media/ListFile.d60434ea.txt";